import { render, staticRenderFns } from "./ArticleCategoriesLayout.vue?vue&type=template&id=6d9802e7&"
import script from "./ArticleCategoriesLayout.vue?vue&type=script&lang=js&"
export * from "./ArticleCategoriesLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports